/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecode_Conversion_FailedInputs */

const en_timecode_conversion_failed = /** @type {(inputs: Timecode_Conversion_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode conversion failed.`)
};

const fr_timecode_conversion_failed = /** @type {(inputs: Timecode_Conversion_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la conversion du timecode.`)
};

const de_timecode_conversion_failed = /** @type {(inputs: Timecode_Conversion_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Timecode-Konvertierung ist fehlgeschlagen.`)
};

const it_timecode_conversion_failed = /** @type {(inputs: Timecode_Conversion_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversione del timecode non riuscita.`)
};

const ru_timecode_conversion_failed = /** @type {(inputs: Timecode_Conversion_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразование временного кода не удалось.`)
};

const es_timecode_conversion_failed = /** @type {(inputs: Timecode_Conversion_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error en la conversión del código de tiempo.`)
};

const zh_cn2_timecode_conversion_failed = /** @type {(inputs: Timecode_Conversion_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间码转换失败。`)
};

const ja_timecode_conversion_failed = /** @type {(inputs: Timecode_Conversion_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコード変換に失敗しました。`)
};

const hi_timecode_conversion_failed = /** @type {(inputs: Timecode_Conversion_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड रूपांतरण विफल रहा।`)
};

const pt_pt2_timecode_conversion_failed = /** @type {(inputs: Timecode_Conversion_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A conversão do código de tempo falhou.`)
};

/**
* | output |
* | --- |
* | "Timecode conversion failed." |
*
* @param {Timecode_Conversion_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode_conversion_failed = /** @type {((inputs?: Timecode_Conversion_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecode_Conversion_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timecode_conversion_failed(inputs)
	if (locale === "de") return de_timecode_conversion_failed(inputs)
	if (locale === "it") return it_timecode_conversion_failed(inputs)
	if (locale === "ru") return ru_timecode_conversion_failed(inputs)
	if (locale === "es") return es_timecode_conversion_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_timecode_conversion_failed(inputs)
	if (locale === "ja") return ja_timecode_conversion_failed(inputs)
	if (locale === "hi") return hi_timecode_conversion_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_timecode_conversion_failed(inputs)
	return en_timecode_conversion_failed(inputs)
});